import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3bb2df84&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=3bb2df84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Users/pongping/htdocs/ufs896@vip/eagleway/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2df84",
  null
  
)

export default component.exports